import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link , useParams, useNavigate, useSearchParams } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {formatDate} from "../../utils/helper";


const List = () => {
    
    const [tab, setTab] = useState("promo_code");
    const [isLoader, setIsLoader] = useState(false);
    const [currency] = useState(process.env.REACT_APP_CURRENCY);
    const [promo_codes, setPromoCodes] = useState([]);
    const [pagination, setPagination] = useState({});
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
   // Initialize state from URL params
    const [apiData, setApiData] = useState({
        search: searchParams.get('search') || "",
        daterange: searchParams.get('daterange') ? 
            JSON.parse(searchParams.get('daterange')) : [],
        page: parseInt(searchParams.get('page')) || 1,
        type: "promo",
    });
    // Update URL when filters change
    useEffect(() => {
        const params = new URLSearchParams();
        if (apiData.search) params.set('search', apiData.search);
        if (apiData.daterange && apiData.daterange.length > 0) params.set('daterange', JSON.stringify(apiData.daterange));
        if (apiData.page > 1) params.set('page', apiData.page.toString());
        
        navigate(`?${params.toString()}`, { replace: true });
    }, [apiData.search, apiData.daterange, apiData.page]);

    
    useEffect(() => {
        getFeatures();
    }, [apiData.page, apiData.search, apiData.daterange, tab]);

    const getFeatures = async () => {
        try {
            setIsLoader(true);
            apiData.type= tab;
            console.log(apiData);
            const response = await ApiService.request({
                method: "GET",
                url: "promo_codes", // Replace with your API endpoint
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setPromoCodes(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            console.log(error);
            setIsLoader(false);
        }
       
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({
            search: '',
            daterange: [],
            page: 1
        });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `promo_codes/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getFeatures();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

 

    const updateStatus = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "you want to change its status!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#4BC95F',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "POST",
                url: `promo_codes/status/${id}`, // Replace with your API endpoint
            });
            const data = response.data;
            if (data.status) {
                getFeatures();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0 text-capitalize">
                           Promo Codes</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Promo Codes</li>
                        </ul>
                    </div>
                    <div className="d-flex align-promo_codes-center gap-2 gap-lg-3">
                        {/* Add New promo_codes Button */}
                        <Link to={`/promo_codes/create?type=${tab}`}  className='btn btn-base btn-sm'>Add New {(tab=='promo_code')?'Promo Code':'Offer'} </Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                         <nav>
                            <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                <button
                                    className={`nav-link fs-lg-4 ${tab === "promo_code" ? "active" : ""}`}
                                    onClick={() => setTab("promo_code")}
                                    id="nav-profile-tab"
                                    type="button"
                                >
                                    <i className="bi bi-percent fs-lg-4"></i> Promo Codes
                                </button>
                                <button
                                    className={`nav-link fs-lg-4 ${tab === "offer" ? "active" : ""}`}
                                    onClick={() => setTab("offer")}
                                    id="nav-contact-tab"
                                    type="button"
                                >
                                    <i className="bi bi-tags fs-lg-4"></i> Offers
                                </button>
                            </div>
                        </nav>
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-promo_codes-center position-relative my-1">
                                                <input type="text" value={apiData.search} onChange={e => setApiData({ ...apiData, search: e.target.value })} className="form-control form-control-solid me-5"
                                                 placeholder={("Search title..")} />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <DatePicker
                                                selectsRange={true}
                                                startDate={apiData.daterange[0]}
                                                endDate={apiData.daterange[1]}
                                                onChange={e => setApiData({ ...apiData, daterange: e })} 
                                                isClearable={true}
                                                maxDate={new Date()}
                                                className='form-control form-control-solid'
                                                placeholderText={('Select Daterange')}
                                            />
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button type="button" onClick={clearFilter} className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.daterange ? 'd-none' : ''}`}>{("clear")}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div id="kt_promo_codes_table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Title</th>
                                                <th>Promo Code</th>
                                                <th>Order Amount</th>
                                                <th>Promo Type</th>
                                                <th>Expiry Type</th>
                                                <th>Status</th>
                                                <th>Created Date</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {promo_codes.length > 0 ? promo_codes.map((cat, index) => (
                                                <tr key={index}>
                                                    
                                                    <td>{cat.title}</td>
                                                    <td><span className='badge bg-base text-gray-100'> {cat.code}</span></td>

                                                    <td>
                                                        Min: {currency} {cat.min_order} <br /> 
                                                        Max: {currency} {cat.max_order}
                                                    </td>
                                                    <td>
                                                        {cat.discount_type} <br /> 
                                                        {cat.discount_type === "Amount"?(
                                                            <span> {currency} {cat.discount}</span>
                                                        ):(
                                                            <span> {cat.discount}%</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {cat.expiry_type}:
                                                        {cat.expiry_type === "Date"?(
                                                            <span>  {formatDate(cat.expiry_date,'DD MMM YYYY')}</span>
                                                        ):(
                                                            <span> {cat.expiry_count}</span>
                                                        )}
                                                    </td>

                                                    <td>
                                                        <div className="form-check form-switch mt-2">
                                                                <input className="form-check-input" type="checkbox" name="is_delivery" id="flexSwitchCheckChecked" checked={cat.status}  
                                                                onClick={() => updateStatus(cat._id)}/>
                                                        </div>
                                                        <button className="p-0 btn btn-transparent">
                                                            <span className={`badge ${cat.status  ? 'badge-light-success' : 'badge-light-danger'}`} onClick={() => updateStatus(cat._id)} >
                                                                {cat.status  ? 'Active' : 'Inactive'}
                                                            </span>
                                                        </button>
                                                    </td>

                                                    <td> {formatDate(cat.createdAt,'DD MMM YYYY, hh:mm A')} </td>
                                                   
                                                    <td className="mt-2">
                                                        <Link to={`/promo_codes/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-eye-fill fs-6"></i>
                                                        </Link>
                                                        <Link to={`/promo_codes/create/${cat._id}`} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-pencil-fill fs-6"></i>
                                                        </Link>
                                                        <button  onClick={() => delData(cat._id)} className="btn btn-sm h-30px btn-light-primary">
                                                            <i className="bi bi-trash-fill fs-6"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="11" className="text-dark text-center mt-2"> No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table> 
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center"  />
                                    )}

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
